import React from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Backdrop,
  useTheme,
  useMediaQuery,
} from "@mui/material";

// ─── Types ────────────────────────────────────────────────────────────────────

interface PricingModalProps {
  open: boolean;
  onClose: () => void;
  onGetStartedClicked: () => void;
}

// ─── PricingModal ─────────────────────────────────────────────────────────────

const PricingModal: React.FC<PricingModalProps> = ({
  open,
  onClose,
  onGetStartedClicked,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      fullScreen={isMobile}
      slots={{ backdrop: Backdrop }}
      slotProps={{
        backdrop: {
          sx: {
            backgroundColor: "rgba(10,10,20,0.6)",
            backdropFilter: "blur(6px)",
          },
        },
      }}
      PaperProps={{
        sx: {
          borderRadius: isMobile ? 0 : "24px",
          overflow: "hidden",           // ← back to hidden; no floating logo here
          background: "#FAFAFA",
          boxShadow: "0 32px 80px rgba(0,0,0,0.25)",
          mx: { xs: 1, sm: 3 },
          // Let the dialog be as wide as maxWidth allows
          width: { xs: "calc(100% - 16px)", sm: "100%" },
          maxHeight: { xs: "95vh", sm: "90vh" },
          animation: "slideUp 0.35s cubic-bezier(0.34,1.56,0.64,1)",
          "@keyframes slideUp": {
            from: { opacity: 0, transform: "translateY(40px) scale(0.96)" },
            to: { opacity: 1, transform: "translateY(0) scale(1)" },
          },
        },
      }}
    >
      <DialogContent
        sx={{
          // Remove all padding so the image goes edge-to-edge
          p: "0 !important",
          overflowY: "auto",
          "&::-webkit-scrollbar": { width: 4 },
          "&::-webkit-scrollbar-thumb": {
            background: "rgba(0,0,0,0.15)",
            borderRadius: 2,
          },
        }}
      >
        <Box
          component="img"
          src="/static/pricing_page/pricing.jpg"
          alt="QR Buddy Pricing"
          onClick={onGetStartedClicked}
          sx={{
            // ── These three lines are the core fix ──
            display: "block",          // removes inline baseline gap
            width: "100%",             // stretch to full dialog width
            height: "auto",            // preserve aspect ratio
            // ────────────────────────────────────────
            cursor: "pointer",
          }}
        />
      </DialogContent>
    </Dialog>
  );
};

export default PricingModal;